import {
  deleteCustomer,
  getAllCustomers,
  getCustomer,
  newCustomer,
  updateCustomer,
} from '../customer-service';

export default {
  /**
   * Get All customers
   * @param commit
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async fetchAllCustomers({ commit }, { page = null, limit = null, query = '' }) {
    const response = await getAllCustomers(page, limit, query);
    const pagination = {
      lastPage: response.lastPage,
      page: response.page,
      perPage: response.perPage,
      total: Number(response.total),
    };
    commit('setProperty', { property: 'customers', payload: response.data });
    commit('setProperty', { property: 'pagination', payload: pagination });
  },

  /**
   *
   *
   * @param context
   * @param customerId
   * @returns {Promise<void>}
   */
  async getCustomer({ commit }, customerId) {
    const response = await getCustomer(customerId);
    commit('setProperty', { property: 'customer', payload: response });
  },

  /**
   *
   * @param commit
   * @param customerId
   * @returns {Promise<void>}
   */
  async deleteCustomer({ commit }, { customerId }) {
    await deleteCustomer(customerId);
    commit('delProperty', { property: customerId });
  },

  /**
   *
   * @param context
   * @param customerId
   * @param customer
   * @returns {Promise<void>}
   */
  async updateCustomer(context, { customerId, customer }) {
    await updateCustomer(customerId, customer);
  },

  /**
   *
   * @param context
   * @param customer
   * @returns {Promise<void>}
   */
  async newCustomer({ commit }, { customer }) {
    const response = await newCustomer(customer);
    commit('setNewCustomer', { payload: response });
    commit('setProperty', { property: 'customer', payload: response });
  },
};
